import styled from 'styled-components';

import { Grid } from 'billon-ui';
const { Row } = Grid;

export const ActionsRow = styled(Row)`
  align-items: center;
  justify-content: end;
`;
